export default "./dist/stdassets/images/icons/toggle.png";